import { FC, FormEvent, useState } from "react";
// @ts-ignore
import defaultLogo from "../../images/titleLogixLogo.png";
import Form from "../../components/common/form/Form";
import Button from "../../components/common/form/Button";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "../user/users/usersApi";
import { handleRTKQuery } from "../../helpers/utils/RtkQueryUtils";
import { showToast } from "../../helpers/utils/Utils";
import { Routes as AppRoutes } from "../../routes";

const ForgotPassword: FC = () => {
    const navigate = useNavigate();
    const [forgotPasswordApi, forgotPasswordApiResponse] = useForgotPasswordMutation();
    const [emailId, setEmailId] = useState<string>("");

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await handleRTKQuery(
            async () => {
                return await forgotPasswordApi(emailId).unwrap();
            },
            () => {
                setEmailId("");
                navigate(AppRoutes.Login.path);
            }
        );
    };

    return (
        <>
            <section className="flex flex-col min-h-[calc(100vh-48px)]">

                {/* Main form section */}
                <div className="flex-grow flex justify-center items-center bg-custom-image bg-center bg-no-repeat bg-cover before:absolute before:inset-0 before:bg-[rgba(0,0,0,30%)] before:content-[''] relative">
                    <div className="flex justify-center">
                        <div className="w-full max-w-xl lg:max-w-lg md:max-w-md">
                            <div className="backdrop-blur-[11px] bg-surface-1 rounded-lg p-12 relative z-10">
                                {/* Form component */}
                                <Form
                                    onSubmit={handleSubmit}
                                    fields={
                                        <>
                                            {/* Logo */}
                                            <div className="text-center mb-4">
                                                <img loading="lazy" src={defaultLogo} alt="" />
                                            </div>

                                            {/* Input field for email */}
                                            <div className=" mb-4 flex items-center ">
                                               <span className="px-3 border-r border-text-3  py-2 rounded-tr-none rounded-br-none rounded bg-[#c0c1c1] inline-block">
                                                    <i className="fa fa-envelope"></i>
                                               </span>
                                                <input  name="email"
                                                        type="email"
                                                        onChange={(e: any) => setEmailId(e.target.value)}
                                                        required={true}
                                                        className="py-2 px-3 w-full  rounded rounded-bl-none rounded-tl-none"
                                                        placeholder="Email"/>

                                            </div>

                                            {/* Reset Password button */}
                                            <div className="form-group mb-4">
                                                <Button
                                                    btnText={"Send Reset Password"}
                                                    isLoading={forgotPasswordApiResponse.isLoading}
                                                    type={"submit"}
                                                    className="text-text-0 font-bold rounded-full px-8 py-2 bg-surface-0 hover:bg-highlight-0"                                                />
                                            </div>

                                            {/* Link to the Login page */}
                                            <div className="forgot-password-txt mb-3">
                                                <button
                                                    className="hover:text-blue-700 cursor-pointer"
                                                    onClick={(e) => {

                                                        e.preventDefault();
                                                        localStorage.clear();
                                                        navigate("/login");
                                                    }}
                                                >
                                                    Remembered Password?
                                                </button>
                                            </div>
                                        </>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ForgotPassword;
